var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L24 -7.15256e-07H1.27811H-7.15256e-07V1.51899V24L12 12Z",
    fill: "#D9BF35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyIcon);
export default __webpack_public_path__ + "static/media/sticky-icon.eee05bda2fd4f79c33c1691ff5ec34a8.svg";
export { ForwardRef as ReactComponent };